import React, { cloneElement, useCallback } from 'react'
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'
import * as ReactPopper from 'react-popper'

const Popper = React.forwardRef(function Popper(props, forwardedRef) {
  const {
    content,
    children,
    placement = 'top',
    isOpen = true,
    portalRef,
  } = props

  const renderPopper = useCallback((content) => {
    if (!isOpen) {
      return null
    }

    if (portalRef) {
      return portalRef.current
        ? createPortal(content, portalRef.current)
        : null
    }

    return content
  }, [isOpen, portalRef])

  return (
    <ReactPopper.Manager>
      <ReactPopper.Reference>
        {({ ref }) => cloneElement(React.Children.only(children), { ref })}
      </ReactPopper.Reference>
      {renderPopper(
        <ReactPopper.Popper
          innerRef={forwardedRef}
          placement={placement}
        >
          {({ placement, ref, style }) =>
            <div style={{ zIndex: 1000000, ...style }} ref={ref} data-placement={placement}>
              {content}
            </div>
          }
        </ReactPopper.Popper>
      )}
    </ReactPopper.Manager>
  )
})

Popper.propTypes = {
  children: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  placement: PropTypes.oneOf([
    'auto',
    'auto-start',
    'auto-end',
    'top',
    'top-start',
    'top-end',
    'right',
    'right-start',
    'right-end',
    'bottom',
    'bottom-start',
    'bottom-end',
    'left',
    'left-start',
    'left-end',
  ]),
  portalRef: PropTypes.object,
}

export default Popper
